import { Component, OnInit, ElementRef, NgZone, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { FormGroup, FormControl, FormArray, Validators } from "@angular/forms";
import { ExportColumnHeaders } from "@shared/models/export-headers.model";
import { ExportService } from "@shared/services/export";
import { MapExportData } from "@shared/data/MapExportData";
import { PermissionPipe } from "@shared/pipes/permission";
import { TabOpenService } from "src/app/services/tab-open.service";
import { Tabs } from "@enums/tab.enum";
import { WorkOrderService } from "@fs/services/work-order";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { ExportType, WOSChangeEventDestination } from "@fs/enums/common";
import { Constants } from "@shared/models/constants";
import { CommonMethods } from "@services/common.method";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { Grid } from "@fs/enums/grid.enum";
import { catchError, debounceTime, switchMap, takeUntil, tap } from "rxjs/operators";
import { of, Subject } from "rxjs";
import { GridFilter } from '@fs/services/grid.mixin';
import { customJS } from "@fs/services/customjs";
@Component({
  selector: "work-order-review-list",
  templateUrl: "./wo-review-list.component.html",
  styleUrls: ["./wo-review-list.component.scss"]
})
export class WorkOrderReviewListComponent extends GridFilter implements OnInit, AfterViewInit {
  protected readonly ngUnsubscribe = new Subject();

  constructor(
    private $elementRef: ElementRef,
    private commonMethod: CommonMethods,
    private exportServ: ExportService,
    private httpService: WorkOrderService,
    private permissionPipe: PermissionPipe,
    private tabopen: TabOpenService,
    private zone: NgZone,
    private dataSharing: DataSharingLTE,
    private changeDetector: ChangeDetectorRef,
    spinnerServ: SpinnerService
  ) {
    super(Grid.WorkOrderReview, spinnerServ);
    //ToDo: Optimizing further requires significant changes in the exisitng services
    this.makeRequest$.pipe(
      debounceTime(Constants.debounceInterval),
      tap(()=> {
        this.setDefaultFilter();
      }),
      switchMap((val:string) => 
      this.httpService.GetWorkOrderReviewList(this.isExport? this.getExportState() : this.state, val).pipe(
      catchError(() => {
        return of({ Data: [], Count: 0 });
      })
    )), 
    takeUntil(this.ngUnsubscribe))
    .subscribe(r => {
      this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
      if (!this.isExport) { 
        this.mapGridData(r);
        this.data.data.forEach(x => {
          x.checkEditDisable = this.commonMethod.IsWorkOrderEditDisabled(x),
          x.CustomerObj = { JobSite: x.JobSite, Customer: { ID: x.CustomerID, DisplayName: "" } }
        });
      } else { 
        this.mapExportData(r); 
      }
    });
    this.registerEvents();
  }

  ngOnInit() {
    this.setPageMetaFilter();
  }

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      customJS.setScroll(this.$elementRef.nativeElement);
    });
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setDefaultFilter() {
    const completedId = this.commonMethod.CompanyModel.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().completed).ID;
    const canceledId = this.commonMethod.CompanyModel.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().cancelled).ID;
    const voidId = this.commonMethod.CompanyModel.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().void).ID;

    if (!this.state.filter) {
      this.state.filter = { logic: "and", filters: [] };
    }

    const completedFilter = (<any>this.state.filter.filters).filter(x => x.value instanceof Array && x.value.indexOf(completedId) != -1);
    const cancelledFilter = (<any>this.state.filter.filters).filter(x => x.value instanceof Array && x.value.indexOf(canceledId) != -1);
    const voidFilter = (<any>this.state.filter.filters).filter(x => x.value instanceof Array && x.value.indexOf(voidId) != -1);

    // Apply default filters only when not applied
    if (completedFilter.length == 0) {
      // Appened to exisitng filter rather creating a new one
      const InStatusFilter = (<any>this.state.filter.filters).find(x => x.field == "StatusID" && x.operator == "in");
      if (InStatusFilter == undefined)
        this.state.filter.filters.push({
          field: "StatusID",
          operator: "in",
          value: [completedId]
        });
      else InStatusFilter.value.push(completedId);
    }
    //Appened to exisitng filter rather creating a new one
    const NInStatusFilter = (<any>this.state.filter.filters).find(
      x => x.field == "StatusID" && x.operator == "nin"
    );
    if (NInStatusFilter == undefined) {
      let nIndata = [];
      if (cancelledFilter.length == 0) nIndata.push(canceledId);
      if (voidFilter.length == 0) nIndata.push(voidId);
      if (nIndata.length > 0)
        this.state.filter.filters.push({
          field: "StatusID",
          operator: "nin",
          value: nIndata
        });
    } else {
      if (voidFilter.length == 0)
        NInStatusFilter.value.push(voidId);
      if (cancelledFilter.length == 0)
        NInStatusFilter.value.push(canceledId);
    }
  }
  
  viewWorkOrderReview(dataItem) {
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderReviewView,
      params: {
        ID: dataItem.ID,
        jobsiteId: dataItem.JobSite.ID,
        customerId: dataItem.CustomerID
      },
      tabTitle: dataItem.WorkTicketNo == null ? " " : dataItem.WorkTicketNo
      // replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteWorkOrderReviewView, action: "focus" }
    });
  }

  editWorkOrderReview(dataItem) {
    if (!this.permissionPipe.transform(this.actionName.EditWorkOrderReview)) {
      return;
    }
    this.tabopen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderReviewEdit,
      params: {
        ID: dataItem.ID,
        jobsiteId: dataItem.JobSite.ID,
        customerId: dataItem.CustomerID
      },
      tabTitle: dataItem.WorkTicketNo == null ? " " : dataItem.WorkTicketNo
      // replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteWorkOrderView, action: "replace" }
    });
  }

  applyFilter(filterSetting: { applyAdvanceFilter: boolean, advanceFilterActive: any } = { advanceFilterActive: true, applyAdvanceFilter: null }, isStateReset: boolean = false) {
    let filterValues = this.filterForm.controls['searchFilters'];
    let filters = jQuery.extend(true, {}, filterValues);
    filters.value.map(x => {
      if (x.field=="PendingAgreement" && !x.value) { x.field = x.field+"#" };
    });
    this.filter(filterSetting, filters);
  }

  private setPageMetaFilter() {
    const values = this.commonMethod.CompanyModel.CodeTypeData.WorkTicketSubStatus.find(
      x => x.Code.toLowerCase() == Constants.WOStaticStatus().readyforreview
    );
    (this.filterForm.get('searchFilters') as FormArray).push(new FormGroup({
      field: new FormControl("SubStatusID", Validators.required),
      operator: new FormControl("in"),
      value: new FormControl([values], Validators.required),
      dateValue: new FormControl(""),
      value1: new FormControl(null),
      data: new FormControl(null),
      isdataloading: new FormControl(null),
      value2: new FormControl(null)
    }));
    this.toggleFilterOptions();
    this.changeDetector.detectChanges();
    this.filterOptionsVc.ApplyFilters();
  }

  private registerEvents() {
    this.dataSharing.OrderStatusChangeEvent.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (!CommonMethods.CheckNullOrUndefined(data.destination, false) && 
            data.destination == WOSChangeEventDestination.WOReviewLanding) {
              this.makeRequest$.next();
          }
        }
    );
  }
  
  private async mapExportData(r) {
    this.isExport = false;
    if (this.exportType == ExportType.Excel) {
      this.exportServ.ExportToExcel({
        exportData: r.Data.map(x => MapExportData.mapWorkOrderReview(x)),
        exportHeadersColumns: ExportColumnHeaders.WorkOrderReviewColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.PDF) {
      this.exportServ.ExportToPDF({
        exportData: r.Data.map(x => MapExportData.mapWorkOrderReview(x)),
        exportHeadersColumns: ExportColumnHeaders.WorkOrderReviewColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.CSV) {
      this.exportServ.ExportToCSV({
        exportData: r.Data.map(x => MapExportData.mapWorkOrderReview(x)),
        exportHeadersColumns: ExportColumnHeaders.WorkOrderReviewColumns,
        columnHeaderNotToBeIncluded: []
      });
    }
  }
}
